import React, { useState, useEffect } from "react";
import dbslidersection from './slidersection.module.css';
import sliderData from "./sliderData";
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function SliderSection() {
  const [currentSlider, setCurrentSlider] = useState(0);

  const changeSlide = (direction) => {
    setCurrentSlider((prev) => {
      const next = prev + direction;
      const total = sliderData.length;
      return (next + total) % total;
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlider((prev) => (prev + 1) % sliderData.length);
    }, 8000);

    return () => clearInterval(interval);
  }, []);

  const current = sliderData[currentSlider];

  return (
    <section className={dbslidersection["slider-hero"]}>
      <div className={dbslidersection["slider-overlay"]}></div>

      {/* Background Image */}
      <img
        src={current.sliderImg}
        alt={current.head}
        className={dbslidersection["slider-bg-image"]}
      />

      {/* Content */}
      <div className={dbslidersection["slider-content-wrapper"]}>
        <div className={dbslidersection["slider-text-block"]}>
          <h1 className={dbslidersection["slider-heading"]}>{current.head}</h1>
          <ul className={dbslidersection["slider-points"]}>
            {current.description.map((point, i) => (
              <li key={i}>{point}</li>
            ))}
          </ul>
          <button className={dbslidersection["slider-cta"]}>Get Started</button>
        </div>

        {/* Fixed Arrows */}
        <div className={dbslidersection["slider-arrows"]}>
          <button onClick={() => changeSlide(-1)}><ChevronLeft /></button>
          <button onClick={() => changeSlide(1)}><ChevronRight /></button>
        </div>

        {/* Fixed Dots */}
        <div className={dbslidersection["slider-dots"]}>
          {sliderData.map((_, i) => (
            <div
              key={i}
              className={`${dbslidersection["dot"]} ${
                i === currentSlider ? dbslidersection["active-dot"] : ""
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
